import { useParams } from 'react-router-dom';
import CopyTxtIconBtn from '../../components/CopyTxtIconBtn';
import SearchResultTitle from '../../components/SearchResultTitle';

const AddressNotFoundPage = () => {
    const { address } = useParams();  
  return (
    <div>
        <div>
            <SearchResultTitle> &nbsp; {address}<CopyTxtIconBtn value={address || ""}/> was not found or not valid.</SearchResultTitle>
            <h5>try again with a different value</h5>
        </div>
    </div>
  )
}

export default AddressNotFoundPage